import * as React from 'react';
import {useDispatch, useSelector} from 'react-redux';

import useI18n from 'src/hooks/useI18n';

import {getAgencyOverview} from 'src/action-creators/agency-overview';
import {getFilteredResponses} from 'src/action-creators/event-responses';
import {hasError} from 'src/utils/redux';
import {handleGenericApiError} from 'src/utils/errors';

import {getFlaggedWords} from 'src/action-creators/flagging';
import {getFiltered} from 'src/selectors/event-responses';

import Loading from 'src/components/lib/loading/loading';
import Dashboard from './dashboard';


const responsesQuery = () => ({
  time_ago: JSON.stringify({days: 30}),
  page: 0,
});

const DashboardContainer = () => {
  const dispatch = useDispatch();
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;

  const [loading, setLoading] = React.useState(true);
  const error = useSelector((state) => hasError(state, getAgencyOverview));

  React.useEffect(() => {
    Promise.all([
      dispatch(getAgencyOverview()),
      dispatch(getFilteredResponses(responsesQuery())),
      dispatch(getFilteredResponses({...responsesQuery(), flagged: true})),
      dispatch(getFlaggedWords()),
    ])
      // @ts-expect-error - TS2345 - Argument of type 'void' is not assignable to parameter of type '((value: [ThunkAction<unknown>, ThunkAction<unknown>, ThunkAction<unknown>, ThunkAction<unknown>]) => [ThunkAction<unknown>, ThunkAction<unknown>, ThunkAction<...>, ThunkAction<...>] | PromiseLike<...>) | null | undefined'.
      .then(setLoading(false))
      .catch((error) => handleGenericApiError(error));
  }, []);

  const name = useSelector(
    // @ts-expect-error - TS2339 - Property 'accounts' does not exist on type 'DefaultRootState'. | TS2339 - Property 'accounts' does not exist on type 'DefaultRootState'.
    (state) => state.accounts.data[state.accounts.authedUserId].name,
  );
  const agencyOverview = useSelector((state) => state.agencyOverview.data);
  const responseData = useSelector((state) =>
    getFiltered(state, responsesQuery()),
  );
  const flaggedResponseData = useSelector((state) =>
    getFiltered(state, {...responsesQuery(), flagged: true}),
  );
  const flaggedWords = useSelector((state) =>
    state.flagging.flaggedWords.map(({word}) => word),
  );

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return (
      <div>
        {t(
          'There_was_an_error_retrieving_the_overview',
          'There was an error retrieving the overview.',
        )}
      </div>
    );
  }

  return (
    <Dashboard
      agencyOverview={agencyOverview}
      name={name}
      multiEntityEnabled={true}
      responseData={responseData}
      flaggedResponseData={flaggedResponseData}
      flaggedWords={flaggedWords}
    />
  );
};

export default DashboardContainer;
